import dotProp from 'dot-prop-immutable'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { selectSet } from '../../actions/project/set'
import PreviewSet from '../../components/PreviewSet'
import DraggableSet from '../DraggableSet'

const CanvasForSets = ({ sets = [],selected, perMeter, selectedIndex = -1, onSelect }) => (
  <Fragment>
    {sets.map((set, i) => (
      <DraggableSet key={i} index={i} position={(set && set.position)? set.position: {x: 0, y: 0}}>
        {set && <PreviewSet
          frames={set.data}
          perMeter={perMeter}
          isSelected={selectedIndex === i}
          index={selectedIndex}
          selected={selected}
          onSelect={() => onSelect(i)}
        />}
      </DraggableSet>
    ))}
  </Fragment>
)

CanvasForSets.propTypes = {
  sets: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          width: PropTypes.number.isRequired,
          height: PropTypes.number.isRequired,
        })
      ),
      position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired,
      }),
    })
  ),
  allowToResize: PropTypes.bool,
  perMeter: PropTypes.number.isRequired,
  selectedIndex: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  sets: dotProp.get(state, 'project.sets', []),
  perMeter: dotProp.get(state, 'project.background.perMeter', 1000),
  selected: dotProp.get(state, 'project.selected', []),
  selectedIndex:
    dotProp.get(state, 'project.selectedObject', '') !== 'set' ? -1 : dotProp.get(state, 'project.selectedIndex', -1),
})

const mapDispatchToProps = dispatch => ({
  onSelect: index => dispatch(selectSet(index)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasForSets)



// WEBPACK FOOTER //
// ./src/containers/DesignedCanvas/CanvasForSets.js